module.exports = __webpack_public_path__ + "assets/img/4-2.c3d2defd.jpg";